/**
 * Launch Readiness test-id registry.
 *
 * Single source of truth for every `data-testid` this module renders.
 * JSX must import from here — no test-id literals in components
 * (shared-test-navigation rule).
 */

import type { LaunchGoalSet } from './types/launchReadiness.types';

export const LAUNCH_READINESS_TEST_IDS = {
  page: 'launch-readiness-page',
  goalTab: (goal: LaunchGoalSet | string) => `launch-readiness-goal-tab-${goal}`,
  milestone: (id: string) => `launch-readiness-milestone-${id}`,
  milestoneAction: 'launch-readiness-milestone-action',
  milestoneSecondaryAction: (id: string) => `launch-readiness-milestone-secondary-action-${id}`,
  milestoneCheck: (checkId: string) => `launch-readiness-milestone-check-${checkId}`,
  optinTrap: 'launch-readiness-optin-trap',
  retry: 'launch-readiness-retry',
  safeRolloutAnchor: 'launch-readiness-safe-rollout-anchor',
  // J2-I2 — safe rollout panel (names mirrored in @test-kit LAUNCH_READINESS)
  safeRolloutPanel: 'safe-rollout-panel',
  safeRolloutStatus: 'safe-rollout-status',
  safeRolloutGuardrail: (key: string) => `safe-rollout-guardrail-${key}`,
  safeRolloutAlert: 'safe-rollout-alert',
  safeRolloutRollback: 'safe-rollout-rollback',
  safeRolloutDisclosure: 'safe-rollout-disclosure',
  safeRolloutEvaluate: 'safe-rollout-evaluate',
} as const;
